import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import userStore from 'entities/user/module/user-store'

import MplusIcon from 'shared/images/m+.png'
import { priceShow } from 'shared/lib/priceShow'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  tranche?: string
  className?: string
  month?: number
}

export const MplusText = ({ tranche, month }: Props) => {
  const { t } = useTranslation()

  if (!userStore?.account?.is_mplus_available) {
    return null
  }

  return (
    <div className={s.mplusText}>
      <ImageLazy
        src={MplusIcon}
        className={s.icon}
      />
      <p className={clsx(s.mplusPrice, 'semi-bold-11')}>
        {t('mplus.from_x_month_text', {
          price: priceShow(tranche),
          month: month,
        })}
      </p>
    </div>
  )
}
